import React from 'react';
import BaseCreatePage from '../../../_CustomComponents/BaseCreatePage';
import { connect } from "react-redux";
import { Portlet, PortletBody, PortletHeader } from "../../../../../partials/content/Portlet";
import { Alert } from "react-bootstrap";
import * as paymentBatchCrud from '../../../../../crud/paymentBatch.crud';
import * as paymentCertificateCrud from '../../../../../crud/paymentCertificate.crud';
import * as contractOtherPriceCrud from '../../../../../crud/contractOtherPrice.crud';
import * as projectOrderCrud from '../../../../../crud/projectOrder.crud';
import BiDynamicForm from '../../../../../partials/layout/BiDynamicForm';
import moment from 'moment';
import { FormattedMessage, injectIntl } from "react-intl";
import { withCreatePageProps } from '../../../../../shared/hoc/withCreatePageProps';
import Common from '../../../../../shared/common';
import { actionCodes, GetCurrencyCodes } from "../../../../../shared/lookup";
import PortletSpinner from '../../../../../partials/layout/PortletSpinner';

const rightAlignedNumberBox = {
    editorOptions: {
        elementAttr: { class: 'text-right' }
    }
};

class FirstWizardPage extends BaseCreatePage {
    constructor(props) {
        super(props);
        this.currencyCodes = GetCurrencyCodes(props.intl);
        if (props.workflowItem.config.currentModelType === "Application") {
            this.customFields = (props.allCustomFields || {})[21];
            if (props.placeholdersQA.ApplicationTypes) {
                this.configurableTypeFields = props.placeholdersQA.ApplicationTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));
            }
        }
        else if (props.workflowItem.config.currentModelType === "Certificate") {
            this.customFields = (props.allCustomFields || {})[20];
            if (props.placeholdersQA.PaymentTypes) {
                this.configurableTypeFields = props.placeholdersQA.PaymentTypes.values.filter(item => item.isActive === true).map(x => ({ value: x.field, display: x.display }));
            }
        }
        try {
            this.taxEnabled = props.placeholdersQA.TaxEnabled
                .values.find(phItem => phItem.field === 'TaxEnabled').isActive;
        } catch (error) {
            console.log("TaxEnabled placeholder not available!");
            this.taxEnabled = true;
        }
        try {
            this.poNumberEnabled = props.placeholdersQA.PONumberEnabled
                .values.find(phItem => phItem.field === 'PONumberEnabled').isActive;
        } catch (error) {
            console.log("PONumberEnabled placeholder not available!");
            this.poNumberEnabled = false;
        }

        this.batchPaymentForPackagedContractEnabled = props.contract.ispackaged;

        if (this.batchPaymentForPackagedContractEnabled) {
            this.projectOrderNotificationName = (this.props.workflowsQA['72'] || {}).notificationName;
        }

        this.state = {
            showAlert: true,
            secondaryPrices: null,
            secondaryPricesLastRetainAmounts: null,
            projectOrders: null
        };
    }

    componentDidMount() {
        this.fetchSecondaryPrices();
    }

    fetchSecondaryPrices = async () => {
        try {
            if (this.batchPaymentForPackagedContractEnabled) {
                await this.fetchProjectOrders();
            } else {
                const contractId = this.props.contract.contractid;
                const { data: pricesResp } = await contractOtherPriceCrud.getContractOtherPrices(contractId);

                // const contractOtherPrices = pricesResp?.filter(p => p.category === "CONTRACT_PRICE" && p.currency !== this.props.contract.currency);

                // if (!contractOtherPrices  || contractOtherPrices.length === 0) {
                //     this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.NO_CURRENCY_DEF' }), { variant: 'error', });
                //     return;
                // }
                // if (contractOtherPrices.length > 6) {
                //     this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.MAX_CURRENCY_DEF' }), { variant: 'error', });
                //     return;
                // }

                if (!pricesResp || pricesResp.length === 0) {
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.NO_CURRENCY_DEF' }), { variant: 'error', });
                    return;
                }
                if (pricesResp.length > 6) {
                    this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.MAX_CURRENCY_DEF' }), { variant: 'error', });
                    return;
                }

                const currencies = pricesResp.filter(p => p.category === "CONTRACT_PRICE").map(x => x.currency);
                //const secondaryPrices = [this.props.contract.currency, ...currencies];
                this.setState({ secondaryPrices: currencies });

                this.fetchLastPaymentAmountsForCurrencies(currencies);

                // const { data: currenciesAndAmountsResp } = await paymentCertificateCrud.getLastPaymentAmounts(contractid, ["Certificate"], currencies, '');

                // //Adding the contract currency as the first item
                // const secondaryPrices = [this.props.contract.currency, ...currencies];

                // //Adding the contract currency and totalCertified value as the first item
                // const contractCurrencyAndTotalCertifiedItem = {
                //     currencycode: this.props.contract.currency,
                //     amount: this.props.contract.totalcertified
                // }

                // const secondaryPricesLastRetainAmounts = [contractCurrencyAndTotalCertifiedItem, ...currenciesAndAmountsResp];

                // this.setState({ secondaryPrices, secondaryPricesLastRetainAmounts });
            }
        }
        catch (err) {
            this.props.enqueueSnackbar(err.toString(), { variant: 'error', });
        }
    }

    fetchLastPaymentAmountsForCurrencies = async (currencies) => {
        try {
            const contractId = this.props.contract.contractid;

            const { data } = await paymentCertificateCrud.getLastPaymentAmounts(
                contractId,
                ["Certificate"],
                currencies,
                ''
            );

            // const contractTotal = {
            //     currencycode: this.props.contract.currency,
            //     amount: this.props.contract.totalcertified
            // };

            // const secondaryPricesLastRetainAmounts = [contractTotal, ...data];

            this.setState({ secondaryPricesLastRetainAmounts: data });
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to fetch last payment amounts for currencies', { variant: 'error', });
        }
    }

    fetchProjectOrders = async () => {
        try {
            const { contractid, ispackaged } = this.props.contract;
            const { data: responseObj } = await projectOrderCrud.getProjectOrdersToSelectList(contractid);

            if (!responseObj || responseObj.length === 0) {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.NO_PROJECTORDER_DEF' }), { variant: 'error', });
                return;
            }

            const projectOrders = responseObj.map(TO => {
                let parts = [];

                if (ispackaged) {
                    // Project Code
                    if (TO.linkedprojectcode) {
                        parts.push(TO.linkedprojectcode);
                    }

                    // PO Number
                    if (TO.projectordernumber) {
                        parts.push(TO.projectordernumber);
                    }

                    // Project Name
                    if (TO.linkedprojectname) {
                        parts.push(TO.linkedprojectname);
                    }
                }

                // Fallback if nothing exists
                let displayValue = parts.length > 0
                    ? parts.join(" - ")
                    : TO.subject;

                return {
                    value: TO.projectorderid,
                    reference: TO.referenceid,
                    display: displayValue
                }
            });
            this.setState({ projectOrders }, () => this.fetchLastPaymentAmountsForProjectOrders());
        } catch (error) {
            console.log(error)
            this.props.enqueueSnackbar('Failed to load communications', { variant: 'error', });
        }
    }

    fetchLastPaymentAmountsForProjectOrders = async () => {
        try {
            const contractId = this.props.contract.contractid;
            const projectOrderIds = this.state.projectOrders.map(x => x.value);

            const { data } = await paymentCertificateCrud.getLastPaymentAmounts(
                contractId,
                ["Certificate"],
                //'', // currencies
                [this.props.contract.currency],
                projectOrderIds
            );

            this.setState({ secondaryPricesLastRetainAmounts: data });
        } catch (err) {
            console.log(err);
        }
    };

    submitHandler = (payment) => {
        payment.companyid = this.props.contract.companyid;
        payment.contractid = this.props.contract.contractid;
        payment.projectid = this.props.contract.projectid;
        payment.assessmentdatedisplay = moment(payment.assessmentdate).format('DD/MM/YYYY');

        payment.type = this.props.workflowItem.config.currentModelType;
        payment.status = 'Not Communicated';
        payment.createdate = new Date();
        payment.createdatedisplay = moment().format('DD/MM/YYYY');

        delete payment.subtotalpayTotal;
        delete payment.subtotalretainTotal;
        delete payment.lastpaymentcertificateamountTotal;
        delete payment.othercumulativepriceTotal;
        delete payment.otheramountpaidTotal;
        delete payment.otheramountretainTotal;
        delete payment.othercertfiedamountTotal;

        const othercumulativeprices = Object.keys(payment)
            .filter(key => key.startsWith('othercumulativeprice'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('othercumulativeprice', ''));
                const numB = parseInt(b.replace('othercumulativeprice', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.othercumulativeprices = othercumulativeprices;

        const otheramountpaids = Object.keys(payment)
            .filter(key => key.startsWith('otheramountpaid'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('otheramountpaid', ''));
                const numB = parseInt(b.replace('otheramountpaid', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.otheramountpaids = otheramountpaids;

        const subtotalpayments = Object.keys(payment)
            .filter(key => key.startsWith('subtotalpay'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('subtotalpay', ''));
                const numB = parseInt(b.replace('subtotalpay', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.subtotalpayments = subtotalpayments;

        const subtotalretains = Object.keys(payment)
            .filter(key => key.startsWith('subtotalretain'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('subtotalretain', ''));
                const numB = parseInt(b.replace('subtotalretain', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.subtotalretains = subtotalretains;

        const otheramountretains = Object.keys(payment)
            .filter(key => key.startsWith('otheramountretain'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('otheramountretain', ''));
                const numB = parseInt(b.replace('otheramountretain', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.otheramountretains = otheramountretains;

        let lastpaymentcertificateamounts = Object.keys(payment)
            .filter(key => key.startsWith('lastpaymentcertificateamount'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('lastpaymentcertificateamount', ''));
                const numB = parseInt(b.replace('lastpaymentcertificateamount', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        const itemCount = this.batchPaymentForPackagedContractEnabled ? this.state.projectOrders.length : this.state.secondaryPrices.length;

        const dif = itemCount - lastpaymentcertificateamounts.length;

        if (dif > 0) {
            for (let index = 0; index < itemCount; index++) {
                if (!Object.keys(payment).includes(`lastpaymentcertificateamount${index + 1}`)) {
                    lastpaymentcertificateamounts.splice(index, 0, (this.state.secondaryPricesLastRetainAmounts[index]?.amount || 0));
                }
            }
        }

        payment.lastpaymentcertificateamounts = lastpaymentcertificateamounts;

        const othercertifiedpretaxes = Object.keys(payment)
            .filter(key => key.startsWith('othercertifiedpretax'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('othercertifiedpretax', ''));
                const numB = parseInt(b.replace('othercertifiedpretax', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.othercertifiedpretaxes = othercertifiedpretaxes;

        const othertaxamounts = Object.keys(payment)
            .filter(key => key.startsWith('othertaxamount'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('othertaxamount', ''));
                const numB = parseInt(b.replace('othertaxamount', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.othertaxamounts = othertaxamounts;

        const othercertfiedamounts = Object.keys(payment)
            .filter(key => key.startsWith('othercertfiedamount'))
            .sort((a, b) => {
                const numA = parseInt(a.replace('othercertfiedamount', ''));
                const numB = parseInt(b.replace('othercertfiedamount', ''));
                return numA - numB;
            })
            .map(key => payment[key]);

        payment.othercertfiedamounts = othercertfiedamounts;

        // const purchaseOrderNumbers = Object.keys(payment)
        //     .filter(key => key.startsWith('purchaseordernumber'))
        //     .map(key => payment[key]);

        // payment.purchaseOrderNumbers = purchaseOrderNumbers;

        payment.currencies = this.batchPaymentForPackagedContractEnabled ?
            this.state.projectOrders.map(() => this.props.contract.currency) : //creates a new array with the exact same length of project orders, filled only with contract.currency
            this.state.secondaryPrices;

        payment.projectorders = this.batchPaymentForPackagedContractEnabled ?
            this.state.projectOrders.map(x => x.value) :
            null;

        payment.actioncode = actionCodes.CREATE;
        this.appendRelationship(payment);
        Common.PropertyConversionsBeforeNoticeSaveRequest(payment, this.customFields, this.props.contractUsers);
        paymentBatchCrud.batchCreateDrafts(payment)
            .then(response => {
                this.props.enqueueSnackbar(this.props.intl.formatMessage({ id: 'GENERAL.COMMUNICATON.DRAFT_SUCCESS' }), { variant: 'success', });
                try {
                    const createdItems = response.data;

                    const paymentBatchId = createdItems?.[0]?.paymentbatchid;

                    this.props.onHandlePaymentCertificateMultipleCurrencies(paymentBatchId);
                    this.props.onValueChanged(false, null);
                    //this.props.navigate(this.props.workflowItem.paths.basePath + createdID);
                }
                catch {
                    this.props.navigate(this.props.workflowItem.paths.listPath);
                }
            })
            .catch(err => {
                this.props.enqueueSnackbar(err.toString(), { variant: 'error', key: "PersistentFormWarning", persist: true });
            });

    }

    calculateDynamicSubTotal = (index, obj) => {
        const prc1 = obj[`othercumulativeprice${index}`] || 0;
        const prc2 = obj[`otheramountpaid${index}`] || 0;
        return prc1 + prc2;
    };

    calculateDynamicAmountDue = (index, obj) => {
        const prc1 = obj[`subtotalpay${index}`] || 0;
        const prc2 = obj[`subtotalretain${index}`] || 0;
        return prc1 - prc2;
    };

    calculateDynamicSubTotalPreTax = (index, obj) => {
        const prc1 = obj[`otheramountretain${index}`] || 0;
        //const prc2 = this.props.contract.totalcertified;
        const prc2 = this.calculateLastPaymentAmount(index, obj);
        return prc1 - prc2;
    };

    calculateDynamicSubTotalPreTaxV2 = (index, obj) => {
        const prc1 = obj[`otheramountretain${index}`] || 0;
        const prc2 = obj[`lastpaymentcertificateamount${index}`] || 0;
        return prc1 - prc2;
    };

    calculateSubTotal = (index, obj) => {
        const lastPaymentAmount = this.calculateLastPaymentAmount(index, obj);

        return lastPaymentAmount != null && lastPaymentAmount != 0
            ? this.calculateDynamicSubTotalPreTax(index, obj)
            : this.calculateDynamicSubTotalPreTaxV2(index, obj);
    }

    calculateDynamicTotal = (index, obj) => {
        const prc1 = obj[`othercertifiedpretax${index}`] || 0;
        const prc2 = obj[`othertaxamount${index}`] || 0;
        return prc1 + prc2;
    };

    calculateRowTotal = (dataFieldBase, obj) => {
        const columnCount = this.batchPaymentForPackagedContractEnabled ?
            this.state.projectOrders.length :
            this.state.secondaryPrices.length;

        let total = 0;
        for (let i = 1; i <= columnCount; i++) {
            const fieldKey = `${dataFieldBase}${i}`;

            //If fieldKey is undefined, set value and break the loop
            if (fieldKey === 'undefined1') {
                total = this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' });
                break; // Exit the loop
            }

            if (this.batchPaymentForPackagedContractEnabled && fieldKey.includes('lastpaymentcertificateamount') && !obj[fieldKey]) {
                total += this.getInitialAmountForIndex(i);
            } else {
                total += (obj[fieldKey] || 0);
            }
        }

        return total;
    };

    formatCurrency = (index) => {
        const cur = this.currencyCodes.find(currency => currency.code === this.state.secondaryPrices[index - 1])?.name || this.state.secondaryPrices[index - 1];
        return cur;
    }

    formatProjectOrder = (index) => {
        const po = this.state.projectOrders[index - 1]?.display;
        return po;
    }

    getInitialAmountForIndex = (index) => {
        const { secondaryPricesLastRetainAmounts } = this.state;

        if (secondaryPricesLastRetainAmounts && index > 0) {
            const prc = secondaryPricesLastRetainAmounts[index - 1];
            return (prc && prc.amount !== undefined) ? prc.amount : 0;
        }

        return 0;
    }

    calculateLastPaymentAmount = (index, obj) => {
        // // const { secondaryPricesLastRetainAmounts } = this.state;

        // // if (secondaryPricesLastRetainAmounts && index > 0) {
        // //     const prc = secondaryPricesLastRetainAmounts[index - 1];

        // //     if (prc && prc.amount !== undefined) {
        // //         return prc.amount;
        // //     }
        // // }

        // // return 0;
        // //if (this.props.contract.totalcertified > 0) {
        //     const { secondaryPricesLastRetainAmounts } = this.state;

        //     // console.log(secondaryPricesLastRetainAmounts);
        //     // console.log(index);

        //     if (secondaryPricesLastRetainAmounts && index > 0) {
        //         const prc = secondaryPricesLastRetainAmounts[index - 1];

        //         if (prc && prc.amount !== undefined) {
        //             return prc.amount;
        //         }
        //     }

        //     return 0;
        // // } else {
        // //     let prc = obj[`lastpaymentcertificateamount${index}`];

        // //     if (prc === undefined) {
        // //         if (prc === undefined && obj[index - 1][`lastpaymentcertificateamount${index}`] !== undefined) {
        // //             prc = obj[index - 1][`lastpaymentcertificateamount${index}`];
        // //         }
        // //     }

        // //     return prc;
        // // }
        if (obj[`lastpaymentcertificateamount${index}`]) {
            let prc = obj[`lastpaymentcertificateamount${index}`];

            if (prc === undefined) {
                if (prc === undefined && obj[index - 1][`lastpaymentcertificateamount${index}`] !== undefined) {
                    prc = obj[index - 1][`lastpaymentcertificateamount${index}`];
                }
            }

            return prc;
        } else {
            const { secondaryPricesLastRetainAmounts } = this.state;

            if (secondaryPricesLastRetainAmounts && index > 0) {
                const prc = secondaryPricesLastRetainAmounts[index - 1];

                if (prc && prc.amount !== undefined) {
                    return prc.amount;
                }
            }

            return 0;
        }
    }

    duplicateFieldWithCount(field, count, calculationFunction) {
        const duplicatedFields = [];

        for (let i = 0; i < count; i++) {
            const colIndex = i + 1;
            const dataField = `${field.dataField}${colIndex}`;

            const duplicatedField = {
                label: `${field.label} ${colIndex}`,
                dataField: `${field.dataField}${colIndex}`,
                required: field.required,
                editorType: field.editorType,
                horizontalfield: true,
                editorOptions: { ...field.editorOptions }
            };

            if (field.dataField === 'lastpaymentcertificateamount') {
                const currentValue = this.state[dataField];

                if (currentValue === undefined) {
                    duplicatedField.editorOptions.value = this.getInitialAmountForIndex(colIndex);
                } else {
                    duplicatedField.editorOptions.value = currentValue;
                    //duplicatedField.editorOptions.readOnly = false;
                }
            }

            // if (field.dataField === 'lastpaymentcertificateamount') {
            //     const initialVal = this.getInitialAmountForIndex(i + 1);
            //     duplicatedField.editorOptions.value = initialVal;
            //     duplicatedField.editorOptions.readOnly = false;
            // }

            if (i === 0 && field.resource) {
                duplicatedField.resource = field.resource;
            }

            duplicatedField.currency = this.batchPaymentForPackagedContractEnabled ?
                this.props.contract.currency :
                this.state.secondaryPrices[i];

            // if (field.value) {
            //     duplicatedField.value = calculationFunction ? calculationFunction.bind(null, i + 1) : undefined;
            // }

            if (field.value && field.dataField !== 'lastpaymentcertificateamount') {
                duplicatedField.value = field.value.bind(null, colIndex);
            }

            duplicatedFields.push(duplicatedField);
        }

        return duplicatedFields;
    }

    generateFieldsWithDuplicates(fields) {
        const updatedFields = [];

        fields.forEach(field => {
            if (field.columnCount) {
                // 1. Generate the standard duplicated fields (Project Order 1, 2, etc.)
                const duplicatedFields = this.duplicateFieldWithCount(field, field.columnCount, field.value);

                // 2. Add the Total column only if batch payment for packaged contract is enabled
                if (this.batchPaymentForPackagedContractEnabled) {
                    // Create the Total field definition
                    const totalField = {
                        label: this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }),
                        dataField: `${field.dataField}Total`,
                        editorType: field.hasOwnProperty('dataField') ? 'dxNumberBox' : 'dxTextBox', //For total label, we use TextBox
                        horizontalfield: true,
                        readOnly: true,
                        value: this.calculateRowTotal.bind(this, field.dataField),
                        editorOptions: {
                            currency: this.props.contract.currency,
                            readOnly: true,
                            elementAttr: { class: 'text-right' }
                        }
                    };
                    duplicatedFields.push(totalField);
                }

                const transformedField = {
                    horizontalrow: true,
                    ...(field.label && { label: field.label }),
                    ...(field.resource && { resource: field.resource }),
                    // The horizontalfields array now contains the base columns and, optionally, the Total column
                    horizontalfields: duplicatedFields.map(duplicatedField => ({ ...duplicatedField }))
                };
                updatedFields.push(transformedField);
            } else {
                updatedFields.push(field);
            }
        });

        return updatedFields;
    }

    onValueChanged = async (e, val) => {
        //this.props.onValueChanged(true, 'first');

        this.setState({
            [e]: val
        });

        // Call base handler if it exists
        // if (super.onValueChanged) {
        //     super.onValueChanged(e);
        // }
    }

    // itemTemplate = data => {
    //     return "<div style={{ position: 'relative', minHeight: '30px', width: '100%', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title='" + data.display + "'>" + data.display + "</div>";  
    // }

    // itemTemplate = data => {
    //     return (
    //         "<div style='position:relative; min-height:30px; width:100%; white-space:nowrap; overflow:hidden; text-overflow:ellipsis;' " +
    //         "title='" + data.display + "'>" + data.display + "</div>"
    //     );
    // };

    // itemTemplate = data => {
    //     // data.display is likely what you want to show and use for the tooltip text
    //     const textToShow = data.display || data.reference; 

    //     // Return JSX, which correctly sets the HTML 'title' attribute for the native tooltip.
    //     return (
    //         <div
    //             style={{ 
    //                 position: 'relative', 
    //                 minHeight: '30px', 
    //                 width: '100%', 
    //                 whiteSpace: 'nowrap', 
    //                 overflow: 'hidden', 
    //                 textOverflow: 'ellipsis' 
    //             }}
    //             title={textToShow} // <--- The crucial 'title' attribute
    //         >
    //             {textToShow}
    //         </div>
    //     );
    // }

    render() {
        if ((this.batchPaymentForPackagedContractEnabled && !this.state.projectOrders) ||
            (!this.batchPaymentForPackagedContractEnabled && !this.state.secondaryPrices) ||
            !this.state.secondaryPricesLastRetainAmounts) {
            return (<PortletSpinner />);
        }

        const bottomLabel = this.props.workflowItem.config.currentModelType === 'Application' ? this.props.resources.PaymentAppliedPeriodLabel : this.props.resources.PaymentCertifiedPeriodLabel;

        const columnCount = this.batchPaymentForPackagedContractEnabled ?
            this.state.projectOrders.length :
            this.state.secondaryPrices.length;

        const createFormConfig = {
            currencyCode: this.props.contract.currency,
            buttonResource: "GENERAL.FORMS.BUTTON_CREATE_DRAFT",
            fields: []
        };

        if (this.configurableTypeFields) {
            createFormConfig.fields.push(
                { resource: "GENERAL.FIELD.APPLICATIONTYPE", dataField: 'paymenttype', editorType: 'dxSelectBox', editorOptions: { dataSource: this.configurableTypeFields, valueExpr: 'value', displayExpr: 'display' } })
        }

        createFormConfig.fields.push(
            { label: this.props.resources.AssessmentDayLabel, dataField: 'assessmentdate', required: true, editorType: 'dxDateBox' },
            { label: this.props.resources.SummaryDetailsLabel, dataField: 'summary', required: true, editorType: 'dxHtmlEditor', },
        )
        // if (this.props.contract.totalcertified != null) {
        //     const lastPaymentField = createFormConfig.fields.find(itm => itm.dataField === 'lastpaymentcertificateamount');
        //     lastPaymentField.value = () => this.props.contract.totalcertified;
        // }

        if (this.batchPaymentForPackagedContractEnabled) {
            // Add the 'Total' label to the end of the Project Order references
            const horizontalLabels = [
                ...this.state.projectOrders.map(x => x.reference),
                this.props.intl.formatMessage({ id: 'PAYMENT.BATCH_WIZARD.TOTAL' }) //Added Total Label
            ];

            createFormConfig.fields.push(
                { horizontallabels: horizontalLabels },
                { label: this.projectOrderNotificationName, value: this.formatProjectOrder, editorType: 'dxTextArea', columnCount: columnCount, editorOptions: { autoResizeEnabled: true }/*, editorOptions: { itemTemplate : this.itemTemplate }*/ },
            )
        } else {
            createFormConfig.fields.push(
                { horizontallabels: this.state.secondaryPrices },
                { resource: "GENERAL.FORMS.CURRENCY", value: this.formatCurrency, editorType: 'dxTextBox', columnCount: columnCount },
            )
        }

        createFormConfig.fields.push(
            { label: this.props.resources.CumulativePriceLabel, dataField: 'othercumulativeprice', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
            { label: this.props.resources.PlusAmountsSupplierLabel, dataField: 'otheramountpaid', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
            { resource: "CONTRACT.WF.PAYMENT.FIELD.SUB_TOTAL", dataField: 'subtotalpay', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicSubTotal, columnCount: columnCount, ...rightAlignedNumberBox },
            { label: this.props.resources.LessAmountsSupplierLabel, dataField: 'subtotalretain', required: true, editorType: 'dxNumberBox', editorOptions: { min: 0 }, columnCount: columnCount, ...rightAlignedNumberBox },
            { resource: "CONTRACT.WF.PAYMENT.FIELD.AMOUNT_DUE", dataField: 'otheramountretain', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicAmountDue, columnCount: columnCount, ...rightAlignedNumberBox },
            //{ label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount', required: true, editorType: 'dxNumberBox'/*, value: this.calculateLastPaymentAmount*/, columnCount: columnCount, ...rightAlignedNumberBox },
        )

        if (this.props.contract.totalcertified != null) {
            createFormConfig.fields.push(
                { label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount', required: true, editorType: 'dxNumberBox', /*value: this.calculateLastPaymentAmount, */columnCount: columnCount, editorOptions: { elementAttr: { class: 'text-right' }, readOnly: true } /*...rightAlignedNumberBox*/ }
            )
        } else {
            createFormConfig.fields.push(
                { label: this.props.resources.LessAmountsDueLabel, dataField: 'lastpaymentcertificateamount', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox/*editorOptions: { elementAttr: { class: 'text-right' }, readOnly: false }*/ }
            )
        }

        if (this.taxEnabled) {
            createFormConfig.fields.push(
                { resource: "CONTRACT.WF.PAYMENT.FIELD.SUB_TOTAL", dataField: 'othercertifiedpretax', required: true, editorType: 'dxNumberBox', value: this.calculateSubTotal, columnCount: columnCount, ...rightAlignedNumberBox },
                { label: this.props.resources.TaxSupplierLabel, dataField: 'othertaxamount', required: true, editorType: 'dxNumberBox', columnCount: columnCount, ...rightAlignedNumberBox },
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: this.calculateDynamicTotal, columnCount: columnCount, ...rightAlignedNumberBox }
            )
        }
        else {
            createFormConfig.fields.push(
                { label: bottomLabel, dataField: 'othercertfiedamount', required: true, editorType: 'dxNumberBox', value: this.calculateSubTotal, columnCount: columnCount, ...rightAlignedNumberBox }
            )
        }

        if (this.poNumberEnabled) {
            createFormConfig.fields.push(
                { resource: 'CONTRACT.FIELD.PO_NUMBER', dataField: 'purchaseordernumber', required: false, editorOptions: { defaultValue: this.props.contract.versionnumber } }
            )
        }

        //const updatedFields = this.generateFieldsWithDuplicates(this.state.createFormConfig.fields);
        const updatedFields = this.generateFieldsWithDuplicates(createFormConfig.fields);

        return (
            <div style={{ height: 'calc(100vh - 215px)', overflowY: 'auto' }}>
                <Portlet>
                    <PortletHeader title={this.props.intl.formatMessage({ id: 'GENERAL.FORMS.CREATE_TITLE' }, { ITEM_NAME: this.props.workflowItem.pageTitle })} />
                    <PortletBody style={{ maxWidth: 1001, height: 'auto' }}>
                        {this.state.showAlert && (
                            <Alert variant="secondary" onClose={() => this.setState({ showAlert: false })} dismissible>
                                <p>
                                    <FormattedMessage id="GENERAL.FORMS.WARNING_DRAFT" />
                                </p>
                            </Alert>
                        )}
                        {this.props.resources.WarningBanner && (
                            <Alert variant="warning" >
                                <p>
                                    {this.props.resources.WarningBanner}
                                </p>
                            </Alert>
                        )}

                        <BiDynamicForm
                            onSubmitHandler={this.submitHandler}
                            //config={{ ...this.state.createFormConfig, fields: updatedFields }}
                            config={{ ...createFormConfig, fields: updatedFields }}
                            customFields={(this.customFields || {}).COMMUNICATION}
                            valueChangeHandler={this.onValueChanged}
                        />

                    </PortletBody>
                </Portlet>
            </div>
        );
    }
}

const mapStateToProps = store => ({
    contract: store.contract.contract,
    allCustomFields: store.contract.customFields,
    contractUsers: store.contract.users
});

export default injectIntl(withCreatePageProps(connect(mapStateToProps)(FirstWizardPage)));